import i18n from '../../i18n';
import { BaseApiClient } from './base-client';

/**
 * Telegram API
 */
export class TelegramApi extends BaseApiClient {
  
  // ===== TELEGRAM SEND API =====
  
  /**
   * Отправить видео в чат Telegram
   */
  async sendVideoToChat(videoUrl: string, videoId: string, prompt?: string, model?: string, isBatch?: boolean): Promise<void> {
    try {
      const response = await this.client.post('/api/telegram/send-video', {
        videoUrl,
        videoId,
        prompt,
        model,
        isBatch
      });
      
      if (!response.data.success) {
        throw new Error(response.data.error || i18n.t('common:error.sendVideo'));
      }
    } catch (error: any) {
      console.error('Error sending video to chat:', error);
      throw error;
    }
  }

  /**
   * Отправить изображение в чат Telegram
   */
  async sendImageToChat(imageUrl: string, imageId: string, prompt?: string, model?: string, isBatch?: boolean): Promise<void> {
    try {
      const response = await this.client.post('/api/telegram/send-image', {
        imageUrl,
        imageId,
        prompt,
        model,
        isBatch
      });
      
      if (!response.data.success) {
        throw new Error(response.data.error || i18n.t('common:error.sendImage'));
      }
    } catch (error: any) {
      console.error('Error sending image to chat:', error);
      throw error;
    }
  }

  /**
   * Отправить файл-документ в чат Telegram
   */
  async sendFileToChat(fileUrl: string, fileName: string, fileType: string = 'document'): Promise<void> {
    try {
      const response = await this.client.post('/api/telegram/send-file', {
        fileUrl,
        fileName,
        fileType
      });
      
      if (!response.data.success) {
        throw new Error(response.data.error || i18n.t('common:error.sendFile'));
      }
    } catch (error: any) {
      console.error('Error sending file to chat:', error);
      throw error;
    }
  }

  /**
   * Отправить группу медиафайлов в чат Telegram (альбом)
   */
  async sendMediaGroupToChat(mediaItems: Array<{ url: string; type: 'image' | 'video'; isFirst?: boolean }>): Promise<void> {
    try {
      const response = await this.client.post('/api/telegram/send-media-group', {
        mediaItems
      });
      
      if (!response.data.success) {
        throw new Error(response.data.error || i18n.t('common:error.sendMediaGroup'));
      }
    } catch (error: any) {
      console.error('Error sending media group to chat:', error);
      throw error;
    }
  }
}

